/**
 * Constants barrel export
 * Central export point for all application constants
 */

export const PREFIX = "into-seal";

export const TIMEOUT = 150;

export const DELETED_RESOURCE_RETENTION_DAYS = 30;

// 부서 '개인'을 직접 고른 상태의 저장값 — null 은 '미설정'과 구분되지 않아 별도 값 사용
export const PERSISTED_PERSONAL = 'PERSONAL';

// 부서 트리 맨 위 '전체' 노드의 id — 서버에 없는 화면 전용 값
export const ROOT_DEPARTMENT_ID = 'root';

export const HTTP_CONTENT_TYPE = {
    MULTIPART: "multipart/form-data",
};

export const DOCUMENT_PARTICIPANT_CONTEXT = {
    ADMIN_MEMBER: "ADMIN_MEMBER",
    DEPT_HEAD: "DEPT_HEAD",
    DOC_REQUESTER: "DOC_REQUESTER",
    DOC_APPROVER: "DOC_APPROVER",
    SEAL_MANAGER: "SEAL_MANAGER",
    SEAL_APPROVER: "SEAL_APPROVER",
};

// Module constants
export {
    INTO_MODULE_FIELD_TYPE,
    INTO_MODULE_GROUP_FIELD_TYPE,
    INTO_MODULE_PARTICIPANT_ID,
} from './module';

// UI constants
export {
    DEVICE_MODE,
    DEVICE_CODE,
    DEVICE_BREAKPOINT,
    EXTRA_COLORS,
} from './ui';

// Page constants
export {
    PAGE_VIEW,
    PAGE_SORT_KEY,
    PAGE_SORT_ORDER,
    PAGE_PERIOD,
    PAGE_CONDITION_KEY,
    PAGE_CONDITION_CONNECTOR,
} from './page';

// Event constants
export {
    SHOW_LOADER,
    CLOSE_LOADER,
    SHOW_ERROR,
    CLOSE_ERROR,
    CallbackKind,
} from './event';
